const TRANSLATED_CLASS_PATTERN = /\btranslated-(ltr|rtl)\b/;

export function isDomTranslated() {
  return typeof document !== 'undefined' && TRANSLATED_CLASS_PATTERN.test(document.documentElement?.className ?? '');
}
